import React, { useState, useEffect } from "react";
import "./index.css";
import avatar from "../../../../assets/images/avatarr.png";
import weigh from "../../../../assets/images/wweigh.png";
import Spinner from "react-bootstrap/Spinner";
import Result from "./Result";
import { switchEndpoint } from "../../../../redux/actions/endpoints";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import EvacuationCodeModal from "./modal";
import SecondEvacuationCodeModal from "./modal/evac2";
import AuthenticateModal from "./modal/authenticate";
import { FaGreaterThan } from "react-icons/fa";
import CreateDriverModal from "./modal/createDriver";

import { Avatar, Button, Typography } from "antd";
import { RightOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { storage } from "../../../../scopedStorage";

const { Title, Text } = Typography;

// Dummy data
const requests = [
  {
    id: "1",
    center: "Switch Collection Center",
    tonnes: 10,
    address: "off Murtala Muhammed Inter'l. Airport Road, Lagos",
    rider: null,
  },
  {
    id: "2",
    center: "Switch Collection Center",
    tonnes: 10,
    address: "off Murtala Muhammed Inter'l. Airport Road, Lagos",
    rider: null,
  },
  {
    id: "3",
    center: "Switch Collection Center",
    tonnes: 10,
    address: "6/8 Ozumba Mbadiwe Street (Opp 1004 Estate), Victoria Island",
    rider: {
      name: "Victor Okoye",
      avatar:
        "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?auto=format&fit=crop&w=96&q=60",
    },
  },
  {
    id: "4",
    center: "Switch Collection Center",
    tonnes: 10,
    address: "6/8 Ozumba Mbadiwe Street (Opp 1004 Estate), Victoria Island",
    rider: {
      name: "Victor Okoye",
      avatar:
        "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=96&q=60",
    },
  },
];

const styles = {
  row: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    padding: "14px 16px",
    borderRadius: 12,
    background: "rgba(34, 197, 94, 0.06)",
    marginBottom: 12,
    flexWrap: "nowrap",
  },
  badge: {
    width: 34,
    height: 34,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #84cc16",
    background: "#1f2937",
    color: "#84cc16",
    fontWeight: 700,
    flexShrink: 0,
  },

  // ✅ critical: allow mid to shrink + hide overflow so it never sits under the button
  mid: {
    display: "flex",
    alignItems: "center",
    gap: 18,
    flex: "1 1 0",
    minWidth: 0,
    overflow: "hidden",
    flexWrap: "nowrap",
  },

  // ✅ all columns shrinkable, no fixed widths
  centerCol: { flex: "1 1 0", minWidth: 0 },
  tonnesCol: { flex: "0 0 auto", whiteSpace: "nowrap" }, // keep compact
  addressCol: {
    flex: "2 1 0",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  // ✅ IMPORTANT: rider must shrink too; auto can resist shrink in some cases
  riderCol: { flex: "1 1 0", minWidth: 0 },

  truncate: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },

  riderWrap: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    minWidth: 0,
    overflow: "hidden",
  },

  // ✅ keep button separate and always visible
  btnWrap: { flex: "0 0 auto", flexShrink: 0 },

  btn: {
    width: 46,
    height: 46,
    borderRadius: 10,
    background: "#84cc16",
    borderColor: "#84cc16",
  },
};

const RequestRow = ({ item, onOpen }) => (
  <div style={styles.row}>
    <div style={styles.badge}>S</div>

    <div style={styles.mid}>
      <div style={styles.centerCol}>
        <Text strong style={{ ...styles.truncate, display: "block", fontSize: 12 }}>
          {item.center}
        </Text>
      </div>

      <div style={styles.tonnesCol}>
        <Text strong style={{ fontSize: 16, whiteSpace: "nowrap" }}>
          {item.tonnes} tonnes
        </Text>
      </div>

      <div style={styles.addressCol}>
        <EnvironmentOutlined style={{ color: "#6b7280", flexShrink: 0 }} />
        <Text style={styles.truncate}>{item.address}</Text>
      </div>

      <div style={styles.riderCol}>
        {item.rider ? (
          <div style={styles.riderWrap}>
            <Avatar size={32} src={item.rider.avatar} />
            <Text style={styles.truncate}>{item.rider.name}</Text>
          </div>
        ) : (
          <Text type="secondary" style={styles.truncate}>
            No Rider Assigned
          </Text>
        )}
      </div>
    </div>

    <div style={styles.btnWrap}>
      <Button
        type="primary"
        icon={<RightOutlined />}
        style={styles.btn}
        onClick={() => onOpen(item)}
      />
    </div>
  </div>
);



const FactoryEvacuation = () => {
  const [stats, setStats] = useState({});
  const [groupedDate, setGroupedDate] = useState({});
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [password, setPassword] = useState(null);
  const [evacuationData, setEvacuationData] = useState([]);
  const [modalInfo, setModalInfo] = useState([]);
  const [modalInfo2, setModalInfo2] = useState({});
  const [evacCode, setEvacCode] = useState(null);
  const [evacPet, setEvacPet] = useState(null);
  const [evacNylon, setEvacNylon] = useState(null);
  // Weighed in per product: { label: kg }. The request says which products are
  // on the truck, so the factory answers in the same terms.
  const [evacGroups, setEvacGroups] = useState({});

  const setEvacGroup = (label, value) =>
    setEvacGroups((prev) => ({ ...prev, [label]: value }));

  const [showAuthenticate, setShowAuthenticate] = useState(false);
  const handleCloseAuthenticate = () => setShowAuthenticate(false);
  const handleShowAuthenticate = () => setShowAuthenticate(true);

  const [showEvacuation1, setShowEvacuation1] = useState(false);
  const handleCloseEvacuation1 = () => setShowEvacuation1(false);
  const handleShowEvacuation1 = () => setShowEvacuation1(true);

  const [showEvacuation2, setShowEvacuation2] = useState(false);
  const handleCloseEvacuation2 = () => setShowEvacuation2(false);
  const handleShowEvacuation2 = () => setShowEvacuation2(true);

  const [showDriver, setShowDriver] = useState(false);
  const handleCloseDriver = () => setShowDriver(false);
  const handleShowDriver = () => setShowDriver(true);

  const othersObj = {};

  const getEvacuationData = () => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/factory/evacuation-requests?status=pending`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data.data.data;
        setEvacuationData(result);
        result.forEach((element) => {
          const date_type = moment(element.created_at).format("DD/MM/YYYY");
          if (date_type in othersObj) {
            othersObj[date_type] = [...othersObj[date_type], element];
          } else {
            othersObj[date_type] = [element];
          }
        });
        setGroupedDate(othersObj);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      });
  };

  const getEvacuationByCode = async (code) => {
    if (!evacCode) {
      toast.error("Please enter evacuation code");
      return;
    }
    try {
      setLoading2(true);
      const token = storage.getItem("token");
      const res = await axios.get(
        `${switchEndpoint}/factory/evacuation-request-details/${code}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.data.data.status == "pending") {
        setModalInfo(res.data.data);
        handleCloseEvacuation1();
        handleShowEvacuation2();
      } else {
        setLoading2(false);
        toast.error("Invalid code");
        return;
      }
      setLoading2(false);
    } catch (error) {
      setLoading2(false);
      // console.log(error)
      toast.error(error?.response?.data?.message);
    }
  };

  const ProcessEvacuation = async () => {
    // A request raised per product is processed per product, so the weight
    // that arrived is recorded against the same products the center declared
    // and the difference reads per product rather than only in aggregate.
    // Requests raised the old way still send the two coarse columns.
    const groups = Array.isArray(modalInfo?.evacuation_groups)
      ? modalInfo.evacuation_groups
          .map((g) => ({ label: g.label, evacuated_kg: parseFloat(evacGroups[g.label]) }))
          .filter((g) => !isNaN(g.evacuated_kg) && g.evacuated_kg > 0)
      : [];

    const payload = groups.length
      ? { code: modalInfo.code, groups, password }
      : {
          code: modalInfo.code,
          evacuated_nylon_kg: evacNylon,
          evacuated_pet_plastic_kg: evacPet,
          password: password,
        };
    try {
      setLoading2(true);
      const token = storage.getItem("token");
      await axios.post(
        `${switchEndpoint}/factory/process-evacuation-request`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Evacuation request processed successfully.");
      handleCloseAuthenticate();
      setEvacCode(null);
      setEvacNylon(null);
      setEvacPet(null);
      setPassword(null);
      setLoading2(false);
      getEvacuationData();
      window.location.reload();
    } catch (error) {
      setLoading2(false);
      console.log(error?.message);
      toast.error(error?.response?.data?.message || error?.message);
    }
  };

  // const getStat = () => {
  //   const token = storage.getItem("token");
  //   axios
  //     .get(`${switchEndpoint}/factory/statistics`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((response) => {
  //       setStats(response.data);
  //       // console.log(response.data);
  //     })
  //     .catch((error) => {
  //       // console.log(error.response.data);
  //       toast.error(error.response.data.message, {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         pauseOnHover: true,
  //         progress: undefined,
  //         theme: "light",
  //       });
  //     });
  // };

  const getStat = () => {
    const token = storage.getItem("token");

    // Get current date
    const today = new Date();

    // Get first day of current month in local timezone
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1);

    // Format dates properly for local timezone
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const start_date = formatDate(startDate);
    const end_date = formatDate(today);

    // console.log('Dates:', { start_date, end_date }); // Debug log

    axios
      .get(`${switchEndpoint}/factory/statistics`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          start_date: start_date,
          end_date: end_date,
        },
      })
      .then((response) => {
        setStats(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        // console.log(error.response.data);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const safeAddAndFormat = (a, b) => {
    const numA = Number(a) || 0;
    const numB = Number(b) || 0;
    const total = numA + numB;
    return `${total.toFixed(3)} kg`;
  };

  useEffect(() => {
    getStat();
    getEvacuationData();
  }, []);

  const unassigned = requests.filter((r) => !r.rider);
  const assigned = requests.filter((r) => !!r.rider);

  const onOpen = (item) => {
    console.log("open:", item.id);
  };
  return (
    <main>
      <div className="separatingDivs px-4">
        <div className="main__cardss">
          <div className="cardsss cards_extra">
            <div className="card_inners_amount mt-4"></div>
            <div className="card_inners text-left">
              <p
                style={{
                  fontWeight: "400",
                  color: "#000",
                  fontSize: "13px",
                  marginLeft: "5px",
                }}
              >
                This Month
              </p>
              {loading ? (
                <div className="card_inners_amount mt-4">
                  <span>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </span>
                </div>
              ) : (
                <h2
                  className="card_inners_amounts"
                  style={{ color: "#c4da00", fontSize: "32px" }}
                >
                  {/* 120.4 */}
                  {Math.round(
                    (stats.total_requests_count + Number.EPSILON) * 100
                  ) / 100}
                  <span
                    style={{
                      fontWeight: "400",
                      color: "#000",
                      fontSize: "13px",
                      marginLeft: "5px",
                    }}
                  >
                    tonnes collected
                  </span>
                </h2>
              )}
            </div>
          </div>
          <div className="cardsss">
            <div className="card_inners">
              <div>
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "10px",
                  }}
                >
                  Center Evacuation
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    overflow: "hidden",
                  }}
                  className="mt-3"
                >
                  <input
                    type="text"
                    placeholder="Enter evacuation code"
                    style={{
                      flex: 1,
                      padding: "10px 12px",
                      border: "none",
                      outline: "none",
                      fontSize: "15px",
                      color: "#333",
                    }}
                    value={evacCode}
                    onChange={(e) => setEvacCode(e.target.value)}
                  />
                  <button
                    style={{
                      backgroundColor: "#C8D92D",
                      border: "none",
                      cursor: "pointer",
                      padding: "10px 14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "background-color 0.2s ease",
                      marginRight: "5px",
                      borderRadius: "5px",
                    }}
                    onClick={() => getEvacuationByCode(evacCode)}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#b8c92a")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#C8D92D")
                    }
                    onFocus={(e) => {
                      e.target.style.outline = "none";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    {loading2 ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      <FaGreaterThan color="#fff" size={16} />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="cardsss">
            <div className="card_inners">
              <div>
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "10px",
                  }}
                >
                  Register Driver
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // border: "1px solid #ccc",
                    borderRadius: "6px",
                    overflow: "hidden",
                  }}
                  className="mt-3"
                >
                  <button
                    style={{
                      backgroundColor: "#C8D92D",
                      border: "none",
                      cursor: "pointer",
                      padding: "10px 40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "background-color 0.2s ease",
                      marginRight: "5px",
                      borderRadius: "5px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#000",
                    }}
                    onClick={() => {
                      handleShowDriver();
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#b8c92a")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#C8D92D")
                    }
                    onFocus={(e) => {
                      e.target.style.outline = "none";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    Click to Register
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div className="main__container">
        <div className="mb-2">
          <h4 className="dropOff__title mt-1 mr-4 mb-2">
            <b>Scheduled Evacuation Requests</b> ({evacuationData?.length || 0})
          </h4>
        </div>
        {/* 
        <div style={{ padding: 24, background: "#fff" }}>
          {!!unassigned.length && (
            <>
              <Title level={5} style={{ marginBottom: 12 }}>
                Unassigned Requests
              </Title>
              {unassigned.map((item) => (
                <RequestRow key={item.id} item={item} onOpen={onOpen} />
              ))}
            </>
          )}

          {!!assigned.length && (
            <>
              <Title level={5} style={{ margin: unassigned.length ? "22px 0 12px" : "0 0 12px" }}>
                Assigned Requests
              </Title>
              {assigned.map((item) => (
                <RequestRow key={item.id} item={item} onOpen={onOpen} />
              ))}
            </>
          )}

          {!unassigned.length && !assigned.length && (
            <Text type="secondary">No requests found.</Text>
          )}
        </div> */}


        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "50px",
            }}
          >
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </div>
        ) : (
          <div>
            {!Object.keys(groupedDate).length ? (
              ""
            ) : (
              <div>
                {Object.keys(groupedDate).length &&
                  Object.keys(groupedDate).map((req, index) => {
                    return (
                      <Result
                        key={req.id}
                        req={req}
                        data={groupedDate[req]}
                        index={index}
                        weigh={weigh}
                        avatar={avatar}
                        safeAddAndFormat={safeAddAndFormat}
                        handleShowEvacuation2={handleShowEvacuation2}
                        setModalInfo={setModalInfo}
                      />
                    );
                  })}
              </div>
            )}
          </div>
        )}
      </div>

      <EvacuationCodeModal
        showEvacuation1={showEvacuation1}
        handleCloseEvacuation1={handleCloseEvacuation1}
        modalInfo={modalInfo}
        evacCode={evacCode}
        setEvacCode={setEvacCode}
        getEvacuationByCode={getEvacuationByCode}
        loading2={loading2}
        handleShowEvacuation2={handleShowEvacuation2}
      />

      <SecondEvacuationCodeModal
        showEvacuation2={showEvacuation2}
        handleCloseEvacuation2={handleCloseEvacuation2}
        modalInfo={modalInfo}
        evacCode={evacCode}
        setEvacCode={setEvacCode}
        handleShowAuthenticate={handleShowAuthenticate}
        modalInfo2={modalInfo2}
        evacNylon={evacNylon}
        evacPet={evacPet}
        setEvacNylon={setEvacNylon}
        setEvacPet={setEvacPet}
        evacGroups={evacGroups}
        setEvacGroup={setEvacGroup}
      />

      <AuthenticateModal
        showAuthenticate={showAuthenticate}
        handleCloseAuthenticate={handleCloseAuthenticate}
        password={password}
        setPassword={setPassword}
        setEvacNylon={setEvacNylon}
        setEvacPet={setEvacPet}
        ProcessEvacuation={ProcessEvacuation}
        loading2={loading2}
      />

      <CreateDriverModal
        showDriver={showDriver}
        handleCloseDriver={handleCloseDriver}
      />
    </main>
  );
};

export default FactoryEvacuation;
